import { axios } from "/@/modules/axios";

export function useGcp() {
  const compressorUri =
    import.meta.env.VITE_GOOGLE_CLOUD_COMPRESSOR_URL ||
    "https://video-compressor-prod-214116192742.asia-northeast2.run.app/compress";

  async function requestCompress(fileName: string) {
    if (!compressorUri) {
      throw new Error("Compressor URI is not defined");
    }

    await fetch(compressorUri, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName,
      }),
    });
  }

  async function generateSignedUrl(file: File) {
    return await axios.get<{
      url: string;
      fileName: string;
      fileType: string;
      fileExtension: string;
    }>("/api/v1/videos/generate_signed_url", {
      params: {
        file_name: file.name,
        file_type: file.type,
        file_extension: file.name.split(".").pop(),
      },
    });
  }

  function uploadWithProgress({
    file,
    url,
    onProgress,
  }: {
    file: File;
    url: string;
    onProgress?: (percent: number) => void;
  }): Promise<void> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open("PUT", url);

      xhr.setRequestHeader("Content-Type", file.type);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && onProgress) {
          const percent = Math.round((event.loaded / event.total) * 100);
          onProgress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(
            new Error(
              `Upload failed with status ${xhr.status}: ${xhr.statusText}`
            )
          );
        }
      };

      xhr.onerror = () => {
        reject(new Error("Network Error during file upload"));
      };

      xhr.send(file);
    });
  }

  async function uploadingMp4(
    file: File,
    onProgress?: (percent: number) => void
  ) {
    // generate signed url -> upload file -> request compress

    const { data } = await generateSignedUrl(file);
    const { url, fileName } = data;

    /*
    await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });
    */

    await uploadWithProgress({
      file,
      url,
      onProgress,
    });

    requestCompress(fileName);

    return {
      fileName,
    };
  }

  return {
    compressorUri,
    requestCompress,
    generateSignedUrl,
    uploadingMp4,
  };
}
